"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const exclamationtriangle = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-exclamationtriangle` : '') + (description ? ` desc-exclamationtriangle` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-exclamationtriangle"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-exclamationtriangle"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_972_1999)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 0.000236511C12.9137 0.000236511 13.7529 0.487405 14.2084 1.26927L14.2942 1.42951L23.7671 20.7271C24.1132 21.4313 24.0713 22.2642 23.6564 22.9301C23.2733 23.5448 22.6224 23.9367 21.9078 23.993L21.728 24H2.27248C1.48786 24.0005 0.758561 23.596 0.34359 22.9301C-0.0394604 22.3154 -0.104583 21.5584 0.159766 20.8921L0.232724 20.7275L9.70581 1.42933C10.1355 0.554526 11.0253 0.000236511 12 0.000236511ZM12 1.50024C11.6421 1.50024 11.3118 1.68118 11.1182 1.9751L11.0522 2.09049L1.57905 21.3889C1.46154 21.6279 1.47575 21.9107 1.61663 22.1368C1.73739 22.3305 1.93655 22.459 2.15904 22.4917L2.27198 22.5H21.7285C21.9949 22.5 22.2425 22.3628 22.3833 22.1368C22.5041 21.943 22.5318 21.7076 22.4631 21.4935L22.4207 21.3885L12.9478 2.09066C12.7703 1.72924 12.4027 1.50024 12 1.50024ZM12 18L12.1226 18.0066C12.6862 18.0677 13.125 18.5451 13.125 19.125C13.125 19.7463 12.6213 20.25 12 20.25C11.3787 20.25 10.875 19.7463 10.875 19.125C10.875 18.5451 11.3137 18.0677 11.8774 18.0066L12 18ZM12 7.5C12.3797 7.5 12.6935 7.78215 12.7431 8.14823L12.75 8.25V15.75C12.75 16.1642 12.4142 16.5 12 16.5C11.6203 16.5 11.3065 16.2178 11.2568 15.8518L11.25 15.75V8.25C11.25 7.83578 11.5858 7.5 12 7.5Z",
    fill: "inherit"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_972_1999"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = exclamationtriangle;